import React from 'react'
import EditKitchen from '../../../components/organisms/admin/kitchen/EditKitchen'

type Props = {}

const EditKichenPage = (props: Props) => {
  return (
    <EditKitchen />
  )
}

export default EditKichenPage